<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="1100px"
    center
    destroy-on-close
    >
    
    <el-form ref="added" :model="formData" :rules="rules" size="medium" label-position="right" label-width="110px">
     <el-form-item label="资讯标题：" prop="title">
        <el-input style="width: 400px;" v-model="formData.title" placeholder="请输入资讯标题" :maxlength='30' show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="分类：" prop="type">
        <el-select v-model="formData.type" placeholder="请选择分类" clearable>
          <el-option :label="item.label" :value="item.value" v-for="(item,i) in types" :key="i"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="缩略图：" prop="thumb">
        <el-upload
          class="avatar-uploader"
          action="#"
          :show-file-list="false"
          :on-change="handleAvatarSuccess"
          :limit='1'
          :auto-upload="false"
          :on-error="uploadError"
          >
          <img v-if="formData.thumb" :src="formData.thumb" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div style="padding-left: 58px;color: #999;">支持JPG/PNG图片格式，文件小于5M</div>
      </el-form-item>
      <el-form-item label="是否外链：" prop="is_external_web">
        <el-switch
          active-text='是'
          inactive-text='否'
          :active-value='1'
          :inactive-value	='0'
          v-model="formData.is_external_web"
         >
        </el-switch>
      </el-form-item>
      <el-form-item label="外链地址：" prop="external_web_link" v-if="formData.is_external_web == 1">
        <el-input style="width: 400px;" v-model="formData.external_web_link" placeholder="输入外链地址，例如：http://www.baidu.com"></el-input>
      </el-form-item>
      
      <el-form-item label="详情：" prop="content" label-width="110px" v-if="formData.is_external_web == 0">
        <Editor width='880px' scene_name='activity' v-model='formData.content'></Editor>
      </el-form-item>
      
      <el-form-item label="状态：" prop="status">
        <el-radio-group v-model="formData.status">
          <el-radio :label="10">已发布</el-radio>
          <el-radio :label="20">已下线</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="排序：" prop="sort">
        <el-input type="number" @input="formData.sort=formData.sort<1?1:parseInt(formData.sort)" style="width: 400px;" v-model="formData.sort" placeholder="请输入排序"></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button @click="save" type="primary">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  import { upload } from '@/api/upload';
  import Editor from '@/components/Editor';
  export default {
    components:{
      Editor
    },
    data() {
      return {
        dialogVisible: false,
        title: '',
        formData: { //弹窗 内容
          title: '',
          type: '',
          is_external_web: 0,
          external_web_link: '',
          thumb: '',
          content: '',
          status: 10, // 资讯状态{10:已发布,20:已下线}
          sort: ''
        },
        types: [
          {label: '社工服务', value: 'community'},
          {label: '志愿风采', value: 'volunteer'}
        ],
        rules: {
          title: [{
            required: true,
            message: '请输入资讯标题',  
            trigger: 'blur'
          }],
          type: [{
            required: true,
            message: '请选择分类',
            trigger: 'change'
          }],
          thumb: [{
            required: false,
            message: '请输入手机号',
            trigger: 'blur'
          }],
          is_external_web: [{
            required: true,
            message: '请选择',
            trigger: 'change'
          }],
          content: [{
            required: true,
            message: '请输入内容',
            trigger: 'blur'
          }],
          external_web_link: [{
            required: true,
            message: '请输入外链地址',
            trigger: 'blur'
          }],
        },
      }
    },
    methods: {
      show(row){
        if(row && row.id){
          this.title = '编辑资讯'
          this.formData = {
            id: row.id,
            title: row.title,
            type: row.type,
            is_external_web: row.is_external_web,
            external_web_link: row.external_web_link,
            thumb: row.thumb,
            content: row.content,
            status: row.status,
            sort: row.sort
          }
        }else{
          this.title = '新增资讯'
          this.formData = {
            title: '',
            type: '',
            is_external_web: 0,
            external_web_link: '',
            thumb: '',
            content: '',
            status: 10,
            sort: ''
          }
        }
        this.dialogVisible = true
      },
      save(formList){
        this.$refs['added'].validate(async valid => {
          if (valid) {
            if(this.formData.id){
              userInfoAPI.updateInformation(this.formData).then(({ data })=>{
                if (data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  this.dialogVisible = false
                  this.$emit('success')
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              })
            }else{
              userInfoAPI.addInformation(this.formData).then(({ data })=>{
                if (data.code == 0) {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'success'
                  })
                  this.dialogVisible = false
                  this.$emit('success')
                } else {
                  this.$message({
                    showClose: true,
                    message: data.msg,
                    type: 'error'
                  });
                }
              })
            }
          }
        })
       
      },
      uploadError(err, file, fileList) {
        this.$message({
            message: "上传出错，请重试！",
            type: "error",
            center: true
          });
        },
      handleAvatarSuccess(file){
        const isIMAGE = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
        const isLt5M = file.raw.size / 1024 / 1024 < 5
        if (!isIMAGE) {
          this.$message({
            showClose: true,
            message: '请选择 jpg、png 格式的图片',
            type: 'warning'
          })
          return false
        }
        if (!isLt5M) {
          this.$message({
            showClose: true,
            message: '图片大小不能超过 5MB',
            type: 'warning'
          })
          return false
        }
        upload([file.raw], 'activity').then((urls)=>{
          this.formData.thumb = urls[0]
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  /deep/{
    .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
      }
      .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
  }
</style>